// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"213388aa","977":"89299236"}[chunkId] + ".chunk.js";
};